exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-spinner{right:0;bottom:0;z-index:10}.mm-spinner,.mm-spinner-mask{position:absolute;top:0;left:0}.mm-spinner-mask{height:100%;width:100%;background:hsla(0,0%,100%,.75);opacity:.8}.mm-spinner-wrapper{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.mm-spinner-text{position:absolute;bottom:-120%;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}", ""]);

// exports
